import IntersectionCapture from '@components/reusable-modules/IntersectionCapture'
import { useModuleContext } from '../contexts/module'

const RecommendationsLazyLoadWrapper = ({ children }) => {
  const { dispatch, state: { artworkInformation, isRecommendationsTriggered } } = useModuleContext()
  const {
    onlineShowId,
    showRecommendations
  } = artworkInformation || {}

  const showRecommendationsRow = onlineShowId && showRecommendations
  return (
    <>
      {isRecommendationsTriggered && children}
      {showRecommendationsRow &&
        <IntersectionCapture
          //@ts-ignore
          onIntersect={() => dispatch({ type: 'TRIGGER_RECOMMENDATIONS', payload: true })}
          active={!isRecommendationsTriggered}
          params={{ rootMargin: '200px' }}
        />}
    </>
  )
}

export default RecommendationsLazyLoadWrapper